import React from 'react'
import { Loading } from '@myxplor/ui'

import { recordActionsToDisplay } from '../../ui/gov-actions'
import RecordDisplayList from '../../ui/record-display-list'

import LocalAsyncStore from '../../local-async-store'

import Empty from './empty'
import changeManconPersonnel from './actions/change-action'
import updateB2BDevice from './actions/update-action'

const levelOneListFields = [
  {
    key: 'device_registration.organisation_id',
    label: 'PRODA RA Organisation ID',
  },
  {
    key: 'personnel.name',
    label: 'Person with Management & Control Name'
  },
  {
    key: 'personnel.gov_person_id',
    label: 'Person with Management & Control ID',
  },
  {
    key: 'device_registration.device_name',
    label: 'Device Name',
  },
  {
    key: 'device_registration.device_expires_at',
    label: 'Device Expiry',
  }
]

const actionsForRecord = ({
  refresh_b2b_device_list,
  apiEndPoint,
}) => ({ record }) => [
  changeManconPersonnel({ record, refresh_b2b_device_list, apiEndPoint }),
  updateB2BDevice({ record, refresh_b2b_device_list, apiEndPoint })
]

export const B2BDeviceList = ({ b2b_device_list, provider_registration_id, refresh_b2b_device_list }) => {
  let { loading, data } = b2b_device_list

  // passing down provider_registration_id
  data.ccs_provider_registration_id = provider_registration_id

  if (loading) return <Loading>Loading B2B Device Registrations</Loading>
  if (data.length === 0) return <Empty />

  return (
    <RecordDisplayList
      {...{
        records: [data],
        name: 'Update B2B Device / Management & Control Personnel',
        level1: levelOneListFields,
        actionButtonsComponent: recordActionsToDisplay({
          actionsForRecord: actionsForRecord({ refresh_b2b_device_list, apiEndPoint: apiEndPoint({ provider_registration_id })}),
        }),
      }}
    />
  )
}

const apiEndPoint = ({ provider_registration_id }) =>
  `/api/device-registrations/provider-reg/${provider_registration_id}`

export default LocalAsyncStore('b2b_device_list', B2BDeviceList, apiEndPoint)




// WEBPACK FOOTER //
// ./src/providers-registrations/b2b-device-list/index.jsx